export default "__VITE_ASSET__BVS0sla1__"